export default "__VITE_ASSET__846007a4__"